import { translateEnum } from 'aos-helpers/src/helpers/translations/Translations'
import { EnumValues } from 'enum-values'
import { TFunction } from 'i18next'

import { TaskType } from '../TaskType'
import { BaseTask } from './BaseTask'
export interface TerminalTask extends BaseTask {
    type: TaskType.Terminal
    terminalTaskType: TerminalTaskType
    licensePlate?: string
    vehicleLocation?: string
    paperSupplement?: string
    observation?: string
}

export enum TerminalTaskType {
    FlagDay = 'FLAG_DAY',
    HeatingWires = 'HEATING_WIRES',
    CUSSParkingMeters = 'CUSS_PARKING',
    FlightChecks = 'FLIGHT_CHECKS',
    Security = 'SECURITY',
    Other = 'OTHER',
}

export const allTerminalTaskTypes = EnumValues.getValues<TerminalTaskType>(TerminalTaskType)

export const translateTerminalTaskType = (t: TFunction) =>
    translateEnum(t)(TerminalTaskType, 'terminal-task-type')
